import firebase from "firebase/app";
import "firebase/auth";

const getFirebaseUser = () => {
  return new Promise((resolve) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export { getFirebaseUser };
